import { render, staticRenderFns } from "./ppChart2.vue?vue&type=template&id=0174b4a2&scoped=true&"
import script from "./ppChart2.vue?vue&type=script&lang=js&"
export * from "./ppChart2.vue?vue&type=script&lang=js&"
import style0 from "./ppChart2.vue?vue&type=style&index=0&id=0174b4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0174b4a2",
  null
  
)

export default component.exports